import React, { useCallback, useEffect, FC } from 'react';

import { SpMerchantCalendarBody } from '../../../../molecules/merchant/calendar/sp/SpMerchantCalendarBody/SpMerchantCalendarBody';
import { ViewStyle } from '../../../../redux/types/merchants/services';
import { Meta, ServiceMap } from '../../../../interfaces/merchants/services';
import {
  ActionsCreators as actions,
  load,
} from '../../../../redux/actions/merchants/services';
import {
  doneLoading,
  hasPrevDate,
} from '../../../../molecules/merchant/calendar/calendarHelper';
import { useFilterSpCalendarBookingPages } from '../../../../hooks/sp-calendar';
import { SpCouponCalendarHeaderOrganisim } from '../SpCouponCalendarHeader';
import { useCouponBookingPageIds } from '../../../../hooks/api/coupon';
import { useAppDispatch } from '../../../../redux';

type Props = {
  merchantPublicId: string;
  merchantTimeZone: string;
  couponPublicId: string;
  baseDate: string;
  fetchedUntil: string;
  viewStyle: ViewStyle;
  meta?: Meta;
  services: ServiceMap;
};

export const SpCouponCalendar: FC<Props> = ({
  baseDate,
  fetchedUntil,
  viewStyle,
  meta,
  services,
  merchantPublicId,
  merchantTimeZone,
  couponPublicId,
}) => {
  const dispatch = useAppDispatch();
  // if baseDate is changed, load new services.
  useEffect(() => {
    load(merchantPublicId, baseDate, fetchedUntil).then(
      (ac) => ac && dispatch(ac),
    );
  }, [dispatch, baseDate, fetchedUntil, merchantPublicId]);

  const scrollNext = useCallback(() => {
    dispatch(actions.scrollNext());
  }, [dispatch]);

  const isList = viewStyle === ViewStyle.List;
  const hasPrev = hasPrevDate(baseDate);

  // body
  const isDoneLoading = doneLoading(baseDate, fetchedUntil);

  const couponBookingPageIds = useCouponBookingPageIds({
    merchantPublicId,
    couponPublicId,
  });
  const filterFn = useFilterSpCalendarBookingPages(couponBookingPageIds);

  const targetBookingPages = filterFn(services);

  return (
    <>
      <SpCouponCalendarHeaderOrganisim
        baseDate={baseDate}
        isList={isList}
        hasPrev={hasPrev}
      />
      <SpMerchantCalendarBody
        merchantPublicId={merchantPublicId}
        isList={isList}
        doneLoading={isDoneLoading}
        fetchNext={scrollNext}
        baseDate={baseDate}
        meta={meta}
        services={targetBookingPages}
        timeZone={merchantTimeZone}
      />
    </>
  );
};
